import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./sidebar";
import Header from "./Header";
import { useBranding } from "@/hooks/useBranding";

const AdminLayout = () => {
  const { branding } = useBranding();
  const [header, setHeader] = useState({ title: "", subTitle: "" });
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const name = branding?.appName || branding?.displayName || "IMS People Possible AI";
    document.title = `${header.title ? `${header.title} | ` : ""}${name}`;
  }, [branding, header.title]);

  // Close sidebar on route change
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Backdrop overlay for mobile / iPad */}
      {sidebarOpen && <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[20] lg:hidden" onClick={() => setSidebarOpen(false)} />}

      <Sidebar isOpen={sidebarOpen} />

      <main className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
        <div className="shrink-0 px-4 pb-3 pt-4">
          <Header title={header.title} subTitle={header.subTitle} onMenuClick={() => setSidebarOpen(true)} />
        </div>
        {/* `pt-2`: a focus ring or a negative-offset badge (Filter's active-count
            pill) on the first row of a page's content has nothing above it to
            bleed into, so the scroll container's own edge clips it — this
            gives that a few px of headroom, same as `pb-4` already does below. */}
        <div className="min-h-0 flex-1 overflow-x-hidden overflow-y-auto px-4 pt-2 pb-4">
          <Outlet context={setHeader} />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
